// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__20UW0","headerContainer":"styles_headerContainer__2QNcu"};